import React from "react";
import ButtonElement from "../element/button/ButtonElement";
import CheckElement from "../element/check/CheckElement";
import FetchElement from "../element/fetch/FetchElement";
import GroupElement from "../element/group/GroupElement";
import MessageElement from "../element/message/MessageElement";
import RadioElement from "../element/radio/RadioElement";
import SelectElement from "../element/select/SelectElement";
import TextElement from "../element/text/TextElement";
import TextareaElement from "../element/textarea/TextareaElement";
import { TextProps } from "../element/text/IText";
import { ButtonProps } from "../element/button/IButton";
import { CheckProps } from "../element/check/ICheck";
import { FetchProps } from "../element/fetch/IFetch";
import { GroupProps } from "../element/group/IGroup";
import { RadioProps } from "../element/radio/IRadio";
import { SelectProps } from "../element/select/ISelect";
import { TextareaProps } from "../element/textarea/ITextarea";
import { MessageProps } from '../element/message/IMessage';
import { Props } from "./types/props";
import { Defines, InputDefines } from "./types/defines";
import { Validate } from "./enum/validate";
import { ElementType } from "./enum/elementType";
import { ColorDefinesType, ColorDefines } from '../interface/IColors';

const selectElement = (
  props: Props, defines: Defines, colors: ColorDefines, key?: number|string
): JSX.Element => {
  if (defines.type !== ElementType.BUTTON && defines.type !== ElementType.MESSAGE) {
    const _validate = [];
    if (defines.required) _validate.push(Validate.NOT_EMPTY);
    defines.validate = Array.from(new Set((defines.validate || []).concat(_validate)));
  }
  if (null == defines.type) defines.type = ElementType.MESSAGE;
  switch (defines.type) {
    case ElementType.MESSAGE:
      return (
        <MessageElement key={key}
          {...{ defines, colors, props: props as MessageProps }}
        ></MessageElement>
      )
    case ElementType.TEXT:
      return (
        <TextElement key={key}
          {...{ defines, colors, props: props as TextProps }}
        ></TextElement>
      );
    case ElementType.BUTTON:
      return (
        <ButtonElement key={key}
          {...{ defines, colors, props: props as ButtonProps }}
        ></ButtonElement>
      );
    case ElementType.SELECT:
      return (
        <SelectElement key={key}
          {...{ defines, colors, props: props as SelectProps }}
        ></SelectElement>
      );
    case ElementType.RADIO:
      return (
        <RadioElement key={key}
          {...{ defines, colors, props: props as RadioProps }}
        ></RadioElement>
      );
    case ElementType.CHECK:
      return (
        <CheckElement key={key}
          {...{ defines, colors, props: props as CheckProps }}
        ></CheckElement>
      );
    case ElementType.GROUP:
      return (
        <GroupElement key={key}
          {...{ defines, colors, props: props as GroupProps}}
        ></GroupElement>
      )
    case "fetch":
      return (
        <FetchElement key={key}
          {...{ defines, colors, props: props as FetchProps}}
        ></FetchElement>
      )
    case "textarea":
      return (
        <TextareaElement key={key}
          {...{ defines, colors, props: props as TextareaProps}}
        ></TextareaElement>
      )
    default:
      return <></>;
  }
}

export const OneFormBuilder = (props: Props, defines: Defines, colors: ColorDefines) => {
  return selectElement(props, defines, colors);
}

export const FormBuilder = (
  arg: {
    props: Props
    defines: Defines,
    colors: ColorDefines
  }[],
  extendKeyNumber?: number|string
): JSX.Element[] => {
  const parentKey = null !== extendKeyNumber && undefined !== extendKeyNumber ? extendKeyNumber + "-" : "";
  return arg.map((a, i) => 
    selectElement(a.props, a.defines, a.colors, parentKey + i)
  )
}